import { TransText } from '@/i18n/trans/text';
import type { CheckoutPassenger } from '@/types/passenger';
import isEmpty from 'lodash/isEmpty';

export const getPassengerName = (
  { firstName, lastName }: Partial<CheckoutPassenger>,
  index: number = 0
) => {
  const fullName = [firstName, lastName].filter(Boolean).join(' ');

  return isEmpty(fullName) ? (
    <TransText i18nKey="passengerIndex" values={{ count: index + 1 }} />
  ) : (
    fullName
  );
};
